import PropTypes from 'prop-types';
import {Message} from 'semantic-ui-react';

const ChangedHostWarning = ({repositoryUrl}) => {
  const content = repositoryUrl ? (
    <div>
      You are modifying the list of URLs your site will be accessible at. Remember to modify it also
      in the{' '}
      <a href={`${repositoryUrl}/pages`} target="_blank" rel="noreferrer">
        Pages settings of your repository
      </a>
      . Click{' '}
      <a
        href="https://how-to.docs.cern.ch/gitlabpagessite/create_site/set_up_pages/"
        target="_blank"
        rel="noreferrer"
      >
        here
      </a>{' '}
      for more information.
    </div>
  ) : (
    <div>
      You are modifying the list of URLs your site will be accessible at. Remember to modify it also
      in the Pages settings of your repository. Click{' '}
      <a
        href="https://how-to.docs.cern.ch/gitlabpagessite/create_site/set_up_pages/"
        target="_blank"
        rel="noreferrer"
      >
        here
      </a>{' '}
      for more information.
    </div>
  );

  return (
    <Message>
      <Message.Header>Change required</Message.Header>
      <Message.Content>{content}</Message.Content>
    </Message>
  );
};

ChangedHostWarning.propTypes = {
  repositoryUrl: PropTypes.string,
};

export default ChangedHostWarning;
